"use client"
import { createSvgIcon, useTheme } from "@mui/material"
import { get } from "lodash"
import type { IconProps } from "../types"

const FileError = createSvgIcon(
  <>
    <g>
      <path d="M8.50427 16.5098V17.498H11.343C11.3674 17.1601 11.4199 16.8297 11.498 16.5098H8.50391H8.50427Z" />
      <path d="M11.6966 20.0082C9.83546 20.0082 7.97393 20.0082 6.11275 20.0082C6.0775 20.0082 6.04226 20.0082 5.99299 20.0082V19.8863C5.99299 14.6306 5.99299 9.37519 5.99299 4.11945C5.99299 4.03892 6.03387 3.99866 6.11563 3.99866C8.70509 3.99866 11.2946 3.99866 13.884 3.99866C13.9677 3.99866 14.0095 4.04096 14.0095 4.12556C14.0095 5.37659 14.0095 6.62761 14.0095 7.87863V8.00266H14.134C15.3884 8.00266 16.6425 8.00266 17.897 8.00266C17.9742 8.00266 18.0129 8.04208 18.0131 8.12093C18.0131 9.41473 18.0131 10.7082 18.0131 12.002C18.3516 12.0422 18.6814 12.1105 19 12.2047C19 10.664 18.9993 9.12319 18.9986 7.58241C18.9986 7.53568 18.9741 7.47708 18.941 7.44401C17.4826 5.98197 16.0218 4.52208 14.5623 3.06075C14.5184 3.0169 14.4753 3 14.4138 3C11.3097 3.00144 8.20554 3.00144 5.10142 3.00144H5V21.0004H12.1735C11.9854 20.6872 11.8254 20.3554 11.697 20.0085L11.6966 20.0082Z" />
      <path d="M8.50391 12.5203V13.4949H13.303C13.7443 13.0973 14.245 12.7648 14.7902 12.5117C12.7258 12.5132 10.6611 12.5132 8.5967 12.5135C8.56541 12.5135 8.53412 12.5182 8.50427 12.5203H8.50391Z" />
    </g>
    <path
      stroke="red"
      d="M15.7583 20.4031L15 19.6448L16.95 17.6948L15 15.7583L15.7583 15L17.7083 16.95L19.6448 15L20.4031 15.7583L18.4531 17.6948L20.4031 19.6448L19.6448 20.4031L17.7083 18.4531L15.7583 20.4031Z"
    />
  </>,
  "FileError",
)

const FileErrorIcon = (props: IconProps) => {
  const { fill, sx, ...rest } = props
  const theme = useTheme()
  const _fill = (fill && get(theme.palette, fill)) || theme.palette.text.primary
  return <FileError sx={{ fill: _fill, ...sx }} {...rest} />
}
export default FileErrorIcon
